// extracted by mini-css-extract-plugin
export default {"logoWrapper":"AppLogo_logoWrapper__9GR6k"};